import { useMemo } from 'react';

interface UsePricingTypeProps {
  preferences: any;
}

export const usePricingType = ({ preferences }: UsePricingTypeProps) => {
  
  const pricingType = preferences?.pricingType || 'hourly';
  
  const derivedTypes = useMemo(() => ({
    isHourlyPrice: pricingType === 'hourly',
    isDailyPrice: pricingType === 'daily',
    isWeeklyPrice: pricingType === 'weekly',
    isMonthlyPrice: pricingType === 'monthly',
    isAgreementPrice: pricingType === 'agreement',
  }), [pricingType]);

  return {
    pricingType,
    ...derivedTypes,
  };
};
